"use client";
import {JSX, useEffect} from "react";

import {cleanupViewportHeight, initViewportHeight} from "@/shared/utils/viewport-height/viewport-height";

export function ViewportHeightProvider(): JSX.Element | null {
    useEffect(() => {
        initViewportHeight();
        return () => cleanupViewportHeight();
    }, []);
    return null;
}
